import styled from 'styled-components';
import { tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
const Counter = styled.div.withConfig({
  displayName: "CharCounter__Counter"
})(["", " position:absolute;bottom:-18px;right:0;"], tombac.text({
  color: tombac.color('neutral', 500),
  fontSize: 11
}));
export const CharCounter = _ref => {
  let {
    value
  } = _ref;
  return /*#__PURE__*/_jsx(Counter, {
    "data-sentry-element": "Counter",
    "data-sentry-component": "CharCounter",
    "data-sentry-source-file": "CharCounter.tsx",
    children: value
  });
};